import { PlayerOrNoneGameStateWithTable } from '../../jscaip/state/PlayerOrNoneGameStateWithTable';
export class PenteState extends PlayerOrNoneGameStateWithTable {
    captures;
    constructor(board, captures, turn) {
        super(board, turn);
        this.captures = captures;
    }
}
